/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetOrgMagicSettingsMutationVariables = Types.Exact<{
  settings: Types.Scalars["OrgMagicSettings"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type SetOrgMagicSettingsMutation = {
  readonly __typename: "Mutation";
  readonly updateOrgMagicSettings: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly magicSettings: c.PartialOrgMagicSettings | null;
  };
};

export const SetOrgMagicSettingsDocument = /*#__PURE__*/ gql`
  mutation setOrgMagicSettings($settings: OrgMagicSettings!, $orgId: OrgId!) {
    updateOrgMagicSettings(settings: $settings, orgId: $orgId) {
      id
      magicSettings
    }
  }
`;
export type SetOrgMagicSettingsMutationFn = Apollo.MutationFunction<
  SetOrgMagicSettingsMutation,
  SetOrgMagicSettingsMutationVariables
>;

/**
 * __useSetOrgMagicSettingsMutation__
 *
 * To run a mutation, you first call `useSetOrgMagicSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrgMagicSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrgMagicSettingsMutation, { data, loading, error }] = useSetOrgMagicSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useSetOrgMagicSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOrgMagicSettingsMutation,
    SetOrgMagicSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetOrgMagicSettingsMutation,
    SetOrgMagicSettingsMutationVariables
  >(SetOrgMagicSettingsDocument, options);
}
export type SetOrgMagicSettingsMutationHookResult = ReturnType<
  typeof useSetOrgMagicSettingsMutation
>;
export type SetOrgMagicSettingsMutationResult =
  Apollo.MutationResult<SetOrgMagicSettingsMutation>;
export type SetOrgMagicSettingsMutationOptions = Apollo.BaseMutationOptions<
  SetOrgMagicSettingsMutation,
  SetOrgMagicSettingsMutationVariables
>;
